import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const PROGRESS_LIST_SUCCESS = api.events.progressList.actionSuccess;
const DISCHARGE_LIST_SUCCESS = api.events.dischargeProgressList.actionSuccess;
const PROGRESS_CREATE_SUCCESS = api.events.progressCreate.actionSuccess;
const DISCHARGE_CREATE_SUCCESS = api.events.dischargeProgressCreate.actionSuccess;
const PROGRESS_DELETE_SUCCESS = api.events.progressDelete.actionSuccess;

const defaultState = { current: null, all: [] };

export default function(state = defaultState, action) {
  switch (action.type) {
    case PROGRESS_CREATE_SUCCESS:
    case DISCHARGE_CREATE_SUCCESS: {
      const payload = action.data?.data || action.data || {};
      const requestArgs = action.args?.[0] || {};
      
      const chapterId = String(payload.chapterId || payload.lessonId || requestArgs.chapterId || '');
      const topicId = String(payload.topicId || payload.lessonPageId || requestArgs.topicId || '');
      
      if (!chapterId || !topicId) return state;

      const safeAll = Array.isArray(state.all) ? state.all : [];
      const chapterExists = safeAll.some(m => String(m.chapterId || m.lessonId) === chapterId);

      let updatedAll = [...safeAll];
      if (!chapterExists) {
        updatedAll.push({ chapterId, topics: [] });
      }

      const all = updatedAll.map(module => {
        if (String(module.chapterId || module.lessonId) !== chapterId) return module;
        
        const safeTopics = Array.isArray(module.topics) ? module.topics : [];
        const topicExists = safeTopics.some(t => {
          const tId = typeof t === 'object' ? (t.topicId || t.topic_id || t.ID || t.id || t.lessonPageId) : t;
          return String(topicId) === String(tId);
        });

        if (topicExists) return module;

        return { 
          ...module, 
          topics: [...safeTopics, { topicId }], 
          updatedAt: action.data?.updatedAt || new Date().toISOString()
        };
      });

      return { ...state, current: payload, all };
    }

    case DISCHARGE_LIST_SUCCESS:
    case PROGRESS_LIST_SUCCESS: {
      const incoming = Array.isArray(action.data) ? action.data : [];
      const merged = [...(Array.isArray(state.all) ? state.all : [])];
      
      incoming.forEach(item => {
        const chapterId = String(item.chapterId || item.lessonId || '');
        if (!chapterId || chapterId === 'null') return;

        const existingIndex = merged.findIndex(m => String(m.chapterId || m.lessonId) === chapterId);
        
        const incomingTopics = Array.isArray(item.topics) ? item.topics : (item.topicId ? [{ topicId: item.topicId }] : []);

        if (existingIndex > -1) {
          // If chapter exists, safely push new topics into its array without overwriting
          const existingChapter = merged[existingIndex];
          const existingTopics = Array.isArray(existingChapter.topics) ? existingChapter.topics : [];

          incomingTopics.forEach(inTopic => {
            const inId = String(typeof inTopic === 'object' ? (inTopic.topicId || inTopic.topic_id || inTopic.ID || inTopic.id || inTopic.lessonPageId) : inTopic);
            if (!existingTopics.some(t => String(typeof t === 'object' ? (t.topicId || t.topic_id || t.ID || t.id || t.lessonPageId) : t) === inId)) {
               existingTopics.push(inTopic);
            }
          });
          existingChapter.topics = existingTopics;
        } else {
          // If chapter is new, create it with the normalized topics array
          merged.push({
            ...item,
            chapterId: chapterId,
            topics: incomingTopics
          });
        }
      });

      return { ...state, all: merged };
    }

    case PROGRESS_DELETE_SUCCESS: {
      const payload = action.data || {};
      const requestArgs = action.args?.[0] || {};
      const chapterId = String(payload.chapterId || requestArgs.chapterId || '');
      const topicId = String(payload.topicId || requestArgs.topicId || '');

      const all = (Array.isArray(state.all) ? state.all : []).map(module => {
        if (String(module.chapterId || module.lessonId) !== chapterId) return module;
        const safeTopics = Array.isArray(module.topics) ? module.topics : [];
        return {
          ...module,
          topics: safeTopics.filter(t => {
            const tId = typeof t === 'object' ? (t.topicId || t.topic_id || t.ID || t.id || t.lessonPageId) : t;
            return String(topicId) !== String(tId);
          })
        };
      });
      return { ...state, all };
    }

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}
